/* ============================================================
   CONFIG — EDIT EVERYTHING HERE
   One place to change copy, CTA labels, prices, billing, and the
   discount. Section copy below feeds the page on load; prices live
   in SIZES / PACKS; featured items live in FEATURED (all further down).
   ============================================================ */
window.__AH_PDP_INIT = true;
const CONFIG = {
  // —— Build-a-box CTA (the main action button label) ——
  buildCta: 'Choose my AppyHour →',

  // —— "Available this season" toggle showcase ——
  feature: {
    eyebrow: 'Available this season',
    footNote: '…and more, rotating each season.',
    ctaBox: 'Choose AppyHour Box',
    ctaBites: 'Choose Gourmet Bites',
  },

  // —— "Choose your AppyHour" builder ——
  builder: {
    eyebrow: 'Two ways to enjoy',
    title: 'Choose your AppyHour',
    sub: 'Start with the experience that fits the moment. Switch anytime before checkout.',
  },

  // —— Pricing / billing (display strings; amounts live in SIZES & PACKS) ——
  appyBilling: 'Billed every 4 weeks · cancel anytime',
  bitesBilling: 'Billed every 4 weeks · cancel anytime',
  shipping: 6.92,

  // —— Discount: prototype mock. In production this comes from the cart
  //    (getCartDiscount → /cart.js). Set to null for no discount. ——
  discount: { code:'WELCOME20', amount:20 },
};

/* ============================================================
   BUILDER COPY + VISIBILITY — section-editable
   Injected from the "AppyHour Build-a-Box" section as window.AH_BUILDER
   (each string = a text/textarea setting; each show* = a checkbox).
   Read here with hard-coded fallbacks so the page never blanks if the
   inject is missing.
   ============================================================ */
const BCFG = Object.assign({
  sizeHeading:       'Choose your size',
  packHeading:       'Choose your pack',
  deliveryHeading:   'First delivery window',
  shipFreeAppy:      '<span class="free-pill">FREE</span> shipping on your first box · under $7 after',
  shipFreeBites:     '<span class="free-pill">FREE</span> shipping on first delivery · reships every 4 weeks',
  stepNote:          "Choose the week your first {item} arrives. Delivered Tue–Fri; we'll confirm the exact day by text.",
  dateConfirmPrefix: 'Arrives chilled · first delivery',
  freeShipLine:      '🚚 Your first box ships free',
  totalLabel:        'Total today',
  savePill:          'You save {amount}',
  customizeNote:     '✎ You can customize your box after checkout.',
  guaranteeText:     '30-Day Happyness Guarantee',
  pickLabel:         'Pick me →',
  sendGiftLabel:     'Send a gift →',
  giftingLabel:      'Gifting? →',
  /* visibility toggles — fallbacks match the launch state */
  showShipFree:      false,
  showStepNote:      false,
  showTotalToday:    false,   // when off, Total today still shows if a discount is in cart
  showGiftingLink:   false,
  showSendGift:      true,
}, window.AH_BUILDER||{});

/* =================== DATA =================== */
const PRODUCTS = {
  appyhour:{ id:'appyhour', name:'AppyHour Box', tag:'Popular', tagClass:'pop',
    img:'https://appyhourbox.com/cdn/shop/files/AppyHour_Subscription_-_Charcuterie_Board.png?v=1764652269&width=500',
    desc:'Expertly curated spread of artisan cheese, charcuterie, pairings and a tasting guide.',
    sub:'Expertly curated artisan cheese & charcuterie, delivered with a tasting guide.',
    inside:['2 artisan cheeses','1 bonus cheese + jam pairing (for life)','2 premium cured meats','2+ accompaniments — nuts & dried fruit','1 pack of artisan crackers','Tasting guide with expert pairings'] },
  bites:{ id:'bites', name:'Gourmet Bites', tag:'New', tagClass:'new',
    img:'https://appyhourbox.com/cdn/shop/files/Gourmet_Bites_1x1_32d61818-c7f9-446d-8f39-32c519f037d9.png?v=1773778415&width=500',
    desc:'Perfectly portioned trays of artisan cheese, charcuterie, and pairings. Grab-and-go, no board required.',
    sub:'The same premium ingredients, pre-portioned into ready-to-eat trays.',
    inside:['Pre-portioned artisan cheeses','Premium cured charcuterie','Cheesemonger pairings','Ready to eat — no board, no prep','Tasting notes included'] }
};
const SIZES=[{id:'medium',name:'Medium',desc:'2 cheeses · 2 meats · 2+ accompaniments',price:89},{id:'large',name:'Large',desc:'Adds an extra meat & cheese',price:109}];
const APPY_BILLING=CONFIG.appyBilling;
const PACKS=[{id:'6',name:'6-Pack',count:6,price:85,badge:null},{id:'10',name:'10-Pack',count:10,price:129,badge:'best value'}];
const BITES_BILLING=CONFIG.bitesBilling;
const SHIP=CONFIG.shipping;
const money=n=>'$'+Math.round(n);
const moneyC=n=>'$'+n.toFixed(2);
const moneyD=n=>{n=Math.round(n*100)/100;return n%1===0?'$'+n:'$'+n.toFixed(2);};

/* ===== DISCOUNT — driven by the cart, not this page =====
   The discount is whatever Shopify has applied to the cart. This page only
   RENDERS it; it never decides codes or amounts. No house fallback: if the
   cart has no discount, nothing shows.

   INTEGRATION SEAM (one spot to wire): getCartDiscount() must return the
   cart's current discount as { code, amount } — or null if none.
   In production, read it from Shopify's cart:

     const r = await fetch('/cart.js').then(r=>r.json());
     const app = (r.cart_level_discount_applications||[])[0]
              || (r.discount_applications||[])[0];
     return app ? { code: app.title, amount: r.total_discount/100 } : null;

   WIRED: hydrateCart() (below) reads /cart.js and caches the discount here. */
/* Cart-level discount, refreshed on every hydrateCart(); null when none. */
let cartDiscount = null;
function getCartDiscount(){ return cartDiscount; }

/* Returns the cart discount clamped to the box subtotal, or null. */
function activeDiscount(boxSub){
  const d=getCartDiscount();
  if(!d || !d.amount) return null;
  return { code:d.code, amount:d.amount, applied:Math.min(d.amount, boxSub||0) };
}
/* Price markup for an option row: shows the discounted price with the original
   struck through when a cart discount is active, else just the price. */
function optPriceHTML(price, unit){
  const d=getCartDiscount();
  if(d && d.amount){
    const off=Math.min(d.amount, price);
    return `<span class="was">${money(price)}</span><span class="pb">${money(price-off)}</span><span class="unit">${unit}</span>`;
  }
  return `<span class="pb">${money(price)}</span><span class="unit">${unit}</span>`;
}

/* real cheese gallery from appyhourbox.com */
const CHEESES=[
  {n:'Italian Baked Lemon Ricotta',d:'Silky, cheesecake-like texture with a bright hint of lemon',img:'https://appyhourbox.com/cdn/shop/files/Pairing.png?v=1755558142&width=500'},
  {n:'Alp Blossom',d:'Smooth, buttery with a striking wildflower-coated rind',img:'https://appyhourbox.com/cdn/shop/files/Alp_Blossom_2.jpg?v=1773339879&width=500'},
  {n:'Honey & Herb Prosciutto',d:'Cured with Iowa honey and a blend of Italian herbs and sea salt',img:'https://appyhourbox.com/cdn/shop/files/Screenshot2025-02-15at4.00.00PM.png?v=1761771520&width=500'},
  {n:'Wooly Wooly Black Garlic',d:'Crafted in Spain with umami-rich black garlic marbling',img:'https://appyhourbox.com/cdn/shop/files/Wooly_Wooly_Black_Garlic_Artisan_Cheese.jpg?v=1764155061&width=500'},
  {n:'Marinated Sheep & Goat Cheese',d:'Award-winning Australian farmstead cheese, rich and smooth',img:'https://appyhourbox.com/cdn/shop/files/marinated_feta_2.webp?v=1758835460&width=500'},
  {n:'Fenugreek Gouda',d:'Dutch-style gouda from Wisconsin with a maple-like sweetness',img:'https://appyhourbox.com/cdn/shop/files/Fenugreek1x1.png?v=1732124214&width=500'},
  {n:'Jamón Ibérico',d:'Nutty, rich ham from purebred Ibérico pigs',img:'https://appyhourbox.com/cdn/shop/files/Texas_Iberico.webp?v=1758835248&width=500'},
  {n:'Everything Bagel Cheese Curds',d:'Crafted on a small farm by a Canadian poutine competition judge',img:'https://appyhourbox.com/cdn/shop/files/Alp_Blossom_2.jpg?v=1773339879&width=500'},
];

/* add-ons — `variant` = live Shopify variant from collection 516016472344
   ("Upsell Pop-up: Monger's Table"). Added one-time (no selling_plan).
   NOTE: Alp Blossom is NOT in that collection, so it has no variant and its
   Add button is gracefully disabled until/unless a variant is provided. */
const AH_LABELS = window.AH_LABELS || {pickerTitle:'Choose your AppyHour', configPrefix:'Build your ', checkout:'Checkout securely →', checkoutEmpty:'Add a box to check out'};
const ADDONS = (window.AH_ADDONS && window.AH_ADDONS.length) ? window.AH_ADDONS : [
  {id:'prosciutto',name:'Honey & Herb Prosciutto',price:9,origin:'Iowa',note:'Cured with honey & Italian herbs',variant:49821698195736,img:'https://appyhourbox.com/cdn/shop/files/Screenshot2025-02-15at4.00.00PM.png?v=1761771520&width=400'},
  {id:'brie',name:'Petit Truffle Brie',price:8,origin:'France',note:'Italian black summer truffle',variant:52113535467800,img:'https://appyhourbox.com/cdn/shop/files/marin-french-cheese-co_petite-truffle-brie.jpg?v=1779979243&width=400'},
  {id:'blacktruffle',name:'Black Truffle Prosciutto',price:12,origin:'USA',note:'Heritage Berkshire pork',variant:51910032097560,img:'https://appyhourbox.com/cdn/shop/files/blacktruffleprosciuttoslices.jpg?v=1780087600&width=400'},
  {id:'olive',name:'Lemon, Feta & Olive Mix',price:9,origin:'Greece',note:'Briny mix with feta chunks',variant:50873685180696,img:'https://appyhourbox.com/cdn/shop/files/AC-LFOD.png?v=1778004119&width=400'},
  {id:'wensleydale',name:'Wensleydale Mango Ginger',price:10,origin:'England',note:'A tropical twist',variant:51478178824472,img:'https://appyhourbox.com/cdn/shop/files/mango_ginger_wens.jpg?v=1776749769&width=400'},
  {id:'peach',name:'Peach Bellini Preserves',price:6,origin:'Italy',note:'Sweet with a sparkling lift',variant:50637689094424,img:'https://appyhourbox.com/cdn/shop/files/Peach.png?v=1777578610&width=400'},
  {id:'blue',name:'California Bay Blue',price:14,origin:'USA',note:'Mellow, earthy, approachable',variant:50539051712792,img:'https://appyhourbox.com/cdn/shop/files/baybluecheese.jpg?v=1758835252&width=400'},
  {id:'alpblossom',name:'Alp Blossom',price:13,origin:'Austria',note:'Wildflower-coated buttery rind',variant:null,img:'https://appyhourbox.com/cdn/shop/files/Alp_Blossom_2.jpg?v=1773339879&width=400'},
];
const BOX_IMG='https://appyhourbox.com/cdn/shop/files/AppyHour_Subscription_-_Charcuterie_Board.png?v=1764652269&width=120';
const BITES_IMG='https://appyhourbox.com/cdn/shop/files/Gourmet_Bites_1x1_32d61818-c7f9-446d-8f39-32c519f037d9.png?v=1773778415&width=120';

/* REVIEWS — add a card by adding an object here. stars defaults to 5. */
const REVIEWS = (window.AH_REVIEWS && window.AH_REVIEWS.length) ? window.AH_REVIEWS : [
  {name:'Ashlee K.', title:'So good!', stars:5, text:"My friends couldn't get over how fresh everything was and all that came in the box. It made our charcuterie night so easy — everything shipped and paired so nicely. Can't wait to order again!"},
  {name:'Denise M.', title:'What a nice gift to send', stars:5, text:"This box was amazing. You guys have thought of everything — how to pair everything together, even with wines. So nice to bring to a friend and have an instant party."},
  {name:'Heidi W.', title:'A happier hour!', stars:5, text:"I've obviously had charcuterie before but not one that told me what pairs with what. It was really fun trying it in an informed manner — and it really made a difference. I'll be bringing the next one to girls night!"},
  {name:'Marcus T.', title:'Better than the cheese shop', stars:5, text:"The quality genuinely surprised me — these are cheeses I'd never find locally. The tasting guide makes me feel like I actually know what I'm talking about now."},
  {name:'Priya S.', title:'Our new Friday ritual', stars:5, text:"We look forward to it every month. It's become the centerpiece of our wind-down — pour some wine, open the box, and we're set. Worth every penny."},
];

/* Featured "what's in your first box" — toggles between AppyHour Box and Gourmet Bites.
   Update each season. Bites items are PLACEHOLDERS — swap names/notes/photos for the real trays. */
const FEATURED = window.AH_FEATURED ? window.AH_FEATURED : {
  appyhour:{
    title:'The Monger\u2019s Table',
    tagline:'A peek into our cheesemongers\u2019 <b>personal stash</b> — the all-time greats they\u2019ve eaten for years and never tire of. This season\u2019s curation, featured in every <b>AppyHour Box</b>.',
    items:[
      {n:'Prairie Breeze Cheddar', kind:'Cheese', d:'Sweet, crystalline Iowa cheddar with caramel notes and a savory bite.', img:'https://appyhourbox.com/cdn/shop/files/Fenugreek1x1.png?v=1732124214&width=600'},
      {n:'Marinated Sheep & Goat Cheese', kind:'Cheese', d:'Award-winning Meredith Dairy farmstead cheese in herbed olive oil — rich and smooth.', img:'https://appyhourbox.com/cdn/shop/files/marinated_feta_2.webp?v=1758835460&width=600'},
      {n:'Tuscan Salami', kind:'Charcuterie', d:'Rustic Italian salame with garlic and cracked black pepper.', img:'https://appyhourbox.com/cdn/shop/files/Texas_Iberico.webp?v=1758835248&width=600'},
      {n:'Lonza', kind:'Charcuterie', d:'Lean, air-dried Italian cured pork loin — savory and delicate.', img:'https://appyhourbox.com/cdn/shop/files/Screenshot2025-02-15at4.00.00PM.png?v=1761771520&width=600'},
      {n:'Praline Pecans', kind:'Accompaniment', d:'Buttery, candied crunch — an irresistible board companion.', img:'https://appyhourbox.com/cdn/shop/files/Alp_Blossom_2.jpg?v=1773339879&width=600'},
    ]
  },
  bites:{
    title:'Gourmet Bites Trays',
    tagline:'The same artisan quality, pre-portioned into <b>ready-to-eat trays</b> — a rotating mix of cheese, charcuterie and pairings in every <b>Gourmet Bites</b> delivery.',
    /* PLACEHOLDER trays — replace with the real Gourmet Bites lineup (names, notes, photos). */
    items:[
      {n:'Cheddar & Salami Tray', kind:'Tray', d:'Aged cheddar paired with cured salami and crackers — a classic snack board in miniature.', img:'https://appyhourbox.com/cdn/shop/files/Gourmet_Bites_1x1_32d61818-c7f9-446d-8f39-32c519f037d9.png?v=1773778415&width=600'},
      {n:'Brie & Prosciutto Tray', kind:'Tray', d:'Creamy brie with delicate prosciutto and a touch of preserves.', img:'https://appyhourbox.com/cdn/shop/files/marin-french-cheese-co_petite-truffle-brie.jpg?v=1779979243&width=600'},
      {n:'Gouda & Almond Tray', kind:'Tray', d:'Smooth gouda with roasted almonds and dried fruit.', img:'https://appyhourbox.com/cdn/shop/files/Alp_Blossom_2.jpg?v=1773339879&width=600'},
      {n:'Olive & Feta Tray', kind:'Tray', d:'Briny olives and feta with a Mediterranean lean.', img:'https://appyhourbox.com/cdn/shop/files/AC-LFOD.png?v=1778004119&width=600'},
    ]
  }
};
let featProduct='appyhour';
/* URL param can default the featured toggle to Gourmet Bites: ?featured=bites or
   ?product=bites (token match — also "gourmet" / "gourmet-bites" / "gourmet bites").
   Tokens "box" / "appyhour" force the box; anything else keeps the default (box).
   Token-split avoids substring false-positives like "boxed" or "gourmetfruit". */
(function(){ try{ const q=new URLSearchParams(location.search); const t=(q.get('featured')||q.get('product')||'').toLowerCase().split(/[^a-z0-9]+/);
  if(t.indexOf('bites')>=0||t.indexOf('bite')>=0||t.indexOf('gourmet')>=0) featProduct='bites';
  else if(t.indexOf('box')>=0||t.indexOf('appyhour')>=0) featProduct='appyhour'; }catch(_){} })();

/* =================== STATE =================== */
let state={ stage:'picker', product:'appyhour', size:'medium', pack:'6', shipIdx:0 };  /* default to the smaller/cheaper 6-pack */

/* =================== windows =================== */
function shipWindows(){ const out=[];const d=new Date(); d.setDate(d.getDate()+((2-d.getDay()+7)%7||7)); for(let i=0;i<6;i++){const s=new Date(d),e=new Date(d);e.setDate(e.getDate()+3);out.push({start:s,end:e});d.setDate(d.getDate()+7);} return out; }
const WINDOWS=shipWindows();
function fmtRange({start,end}){ const sm=start.getMonth()===end.getMonth(); const s=start.toLocaleDateString('en-US',{weekday:'short',month:'short',day:'numeric'}); const e=end.toLocaleDateString('en-US',{weekday:'short',month:sm?undefined:'short',day:'numeric'}); return s+' – '+e; }

/* =================== ship-week shift (default = what the product's PDP does) ===================
   Mirrors product-form-v2_2.js ShipDefaultPolicy exactly: during the shop's configured
   rush window the default jumps to the SECOND window (skip same-week rush → next week);
   per-product opt-out via custom.disable_ship_week_shift (Box shifts, Bites opted out).
   Injected by appyhour-builder.liquid as window.AH_RUSH_WINDOW + window.AH_SHIFT_DISABLE. */
const DAY_INDEX={sunday:0,monday:1,tuesday:2,wednesday:3,thursday:4,friday:5,saturday:6};
function minuteOfWeek(date,tz){ const p=new Intl.DateTimeFormat('en-US',{timeZone:tz,hour12:false,weekday:'long',hour:'2-digit',minute:'2-digit'}).formatToParts(date).reduce((a,x)=>(a[x.type]=x.value,a),{}); return DAY_INDEX[p.weekday.toLowerCase()]*1440+(parseInt(p.hour,10)%24)*60+parseInt(p.minute,10); }
function timeToMow(day,hhmm){ const [h,m]=hhmm.split(':').map(Number); return DAY_INDEX[day.toLowerCase()]*1440+h*60+m; }
function insideRushWindow(){ const c=window.AH_RUSH_WINDOW; if(!c||!c.enabled) return false; try{ const now=minuteOfWeek(new Date(),c.timezone||'America/New_York'); const s=timeToMow(c.starts.day,c.starts.time),e=timeToMow(c.ends.day,c.ends.time); return s<=e?(now>=s&&now<=e):(now>=s||now<=e); }catch(_){ return false; } }
/* default window index for a product: next week (idx 1) when the shift applies, else soonest (0) */
function defaultShipIdx(product){ const disabled=(window.AH_SHIFT_DISABLE||{})[product]; return (!disabled && WINDOWS.length>=2 && insideRushWindow())?1:0; }
state.shipIdx=defaultShipIdx(state.product);   // initial default = what the product's PDP defaults to

/* =================== pricing =================== */
function appyTotal(){ return SIZES.find(s=>s.id===state.size).price; }
function bitesTotal(){ return PACKS.find(p=>p.id===state.pack).price; }
function currentTotal(){ return state.product==='appyhour'?appyTotal():bitesTotal(); }
function currentBilling(){ return state.product==='appyhour'?APPY_BILLING:BITES_BILLING; }

/* =================== builder markup =================== */
function pickerHTML(){ return `<div class="picker">${Object.values(PRODUCTS).map(p=>`
  <button class="pcard ${state.product===p.id&&state.stage!=='picker'?'on':''}" onclick="pickProduct('${p.id}')">
    <span class="pc-img"><img src="${p.img}" alt="${p.name}" loading="lazy"></span>
    <span class="pc-body"><span class="pc-name">${p.name}</span><span class="pc-desc">${p.desc}</span><span class="pc-pick">${BCFG.pickLabel}</span></span>
  </button>`).join('')}${BCFG.showSendGift?`<div class="picker-foot"><a href="#">${BCFG.sendGiftLabel}</a></div>`:''}</div>`; }

function appyConfigHTML(){ return `
  <div class="cfg-step"><div class="cfg-head"><span class="num">1</span><h4>${BCFG.sizeHeading}</h4></div>
    ${BCFG.showShipFree?`<p class="ship-free">${BCFG.shipFreeAppy}</p>`:''}
    <div class="opt-list">${SIZES.map(s=>`<button class="opt ${s.id===state.size?'on':''}" onclick="pickSize('${s.id}')"><span class="opt-top"><span class="radio"></span><span class="opt-main"><span class="opt-name">${s.name}</span><span class="opt-save">${s.desc}</span></span><span class="opt-price">${optPriceHTML(s.price,'/box')}</span></span></button>`).join('')}</div></div>
  ${windowStepHTML(2)}${totalBlockHTML()}`; }

function bitesConfigHTML(){ return `
  <div class="cfg-step"><div class="cfg-head"><span class="num">1</span><h4>${BCFG.packHeading}</h4></div>
    ${BCFG.showShipFree?`<p class="ship-free">${BCFG.shipFreeBites}</p>`:''}
    <div class="opt-list">${PACKS.map(p=>`<button class="opt ${p.id===state.pack?'on':''}" onclick="pickPack('${p.id}')">${p.badge?`<span class="opt-badge accent">${p.badge}</span>`:''}<span class="opt-top"><span class="radio"></span><span class="opt-main"><span class="opt-name">${p.name}</span><span class="opt-save">${p.count} ready-to-eat trays</span></span><span class="opt-price">${optPriceHTML(p.price,'/delivery')}</span></span></button>`).join('')}</div></div>
  ${windowStepHTML(2)}${totalBlockHTML()}`; }

function windowStepHTML(num){ return `<div class="cfg-step"><div class="cfg-head"><span class="num">${num}</span><h4>${BCFG.deliveryHeading}</h4></div>
  ${BCFG.showStepNote?`<p class="step-note">${BCFG.stepNote.replace('{item}', state.product==='bites'?'delivery':'box')}</p>`:''}
  <div class="weeks">${WINDOWS.map((w,i)=>`<button class="week ${i===state.shipIdx?'on':''}" onclick="pickWeek(${i})"><span class="week-label">${i===0?'Soonest':w.start.toLocaleDateString('en-US',{month:'short'})}</span><span class="week-days">${w.start.getDate()}–${w.end.getDate()}</span><span class="week-dow">Tue–Fri</span></button>`).join('')}</div>
  <p class="date-confirm">${BCFG.dateConfirmPrefix} <strong>${fmtRange(WINDOWS[state.shipIdx])}</strong></p></div>`; }

function totalBlockHTML(){
  const boxSub=currentTotal();                 // box/pack price (first delivery)
  const disc=activeDiscount(boxSub);           // cart-driven; null if none
  const applied=disc?disc.applied:0;
  const preTotal=boxSub+SHIP;                  // before savings: price + the shipping we waive
  const today=Math.ceil(boxSub-applied);       // first delivery ships free
  const saved=(preTotal-today);
  const hasSave=applied>0;                     // only show savings UI when a discount is active
  const showTotal = hasSave || BCFG.showTotalToday;   // Total today is off by default; always shows when a discount is in cart
  return `${showTotal?`<div class="cfg-total">
      <span class="tl">${BCFG.totalLabel}</span>
      <span class="tv">${hasSave?`<span class="cfg-was">${moneyC(preTotal)}</span>`:''}${money(today)}</span>
    </div>`:''}
    ${hasSave?`<div class="cfg-save"><span class="cfg-save-pill">${BCFG.savePill.replace('{amount}',moneyC(saved))}</span><span class="cfg-save-detail">${disc.code} (−${money(applied)}) · 1st box ships free</span></div>`:`<p class="cfg-freeship">${BCFG.freeShipLine}</p>`}
    <button class="add-btn" onclick="addConfiguredToCart()">Add to cart</button>
    <p class="cfg-customize">${BCFG.customizeNote}</p>
    <p class="cfg-billing">${currentBilling()} · ${BCFG.guaranteeText}${BCFG.showGiftingLink?` · <a href="#" style="color:var(--coral);font-weight:800;text-decoration:underline">${BCFG.giftingLabel}</a>`:''}</p>`;
}

/* =================== render =================== */
function renderBuilder(){
  if(!document.getElementById('builder')) return;
  const isPicker=state.stage==='picker';
  document.getElementById('builderBody').innerHTML = isPicker?pickerHTML():(state.product==='appyhour'?appyConfigHTML():bitesConfigHTML());
  document.getElementById('builderTitle').textContent = isPicker?AH_LABELS.pickerTitle:(AH_LABELS.configPrefix+PRODUCTS[state.product].name);
  document.getElementById('backBar').style.display=isPicker?'none':'flex';
  document.getElementById('crumb').textContent=PRODUCTS[state.product].name;
  // sticky bar
  updateSticky();
}

/* galleries */
(function(){ const f=document.getElementById('favGrid'); if(f) f.innerHTML=ADDONS.map(a=>`<div class="fav"><div class="fph"><span class="origin">${a.origin}</span><img src="${a.img}" alt="${a.name}" loading="lazy"></div><div class="fb"><h3>${a.name}</h3><div class="fd">${a.note}</div><div class="frow"><span class="fprice">+$${a.price}</span><button class="fadd" onclick="addAddon('${a.id}',true)">Add</button></div></div></div>`).join('');
  const sc=document.getElementById('featShowcase'); if(sc) renderFeatured();
})();

/* Featured section toggle (AppyHour Box / Gourmet Bites) */
function renderFeatured(){
  const f=FEATURED[featProduct];
  const t=document.getElementById('featTitle'); if(t) t.textContent=f.title;
  const tag=document.getElementById('featTagline'); if(tag) tag.innerHTML=f.tagline;
  const sc=document.getElementById('featShowcase'); if(sc) sc.innerHTML=f.items.map(m=>`<div class="sc-card"><div class="sc-img">${m.kind&&m.kind.trim()?`<span class="sc-kind">${m.kind}</span>`:''}<img src="${m.img}" alt="${m.n}" loading="lazy"></div><div class="sc-b"><h3>${m.n}</h3><p>${m.d}</p></div></div>`).join('');;
  const tb=document.getElementById('featTabBox'), tbi=document.getElementById('featTabBites');
  if(tb&&tbi){ tb.classList.toggle('on',featProduct==='appyhour'); tbi.classList.toggle('on',featProduct==='bites'); }
  const cta=document.getElementById('featCta'); if(cta) cta.textContent = f.cta || (featProduct==='appyhour' ? CONFIG.feature.ctaBox : CONFIG.feature.ctaBites);
}
function setFeat(p){ featProduct=p; renderFeatured(); }
/* CTA: preselect the toggled product in the builder and scroll down to it,
   so they pick size (Med/Large) or pack (6/10) before adding to cart. */
function chooseFeat(){ state.product=featProduct; state.shipIdx=defaultShipIdx(featProduct); state.stage='config'; renderBuilder(); scrollToBuilder(); }
function scrollToBuilder(){ const el=document.getElementById('builder'); if(!el) return scrollToPlans(); const y=el.getBoundingClientRect().top+window.pageYOffset-(promoStickyH()+24); window.scrollTo({top:y,behavior:'smooth'}); }

/* handlers */
function pickProduct(id){ state.product=id; state.shipIdx=defaultShipIdx(id); state.stage='config'; renderBuilder(); }
function goPicker(){ state.stage='picker'; renderBuilder(); }
function pickSize(id){ state.size=id; renderBuilder(); }
function pickPack(id){ state.pack=id; renderBuilder(); }
function pickWeek(i){ state.shipIdx=i; renderBuilder(); }
function updateSticky(){
  const btn=document.getElementById('stickyBtn'); if(!btn) return;
  const meta=document.getElementById('stickyMeta');
  const isPicker = state.stage==='picker';
  const hasBox = (cartState.items||[]).some(isSubItem);
  if(meta) meta.textContent = isPicker ? 'Pick a box to start'
    : (PRODUCTS[state.product].name + (state.product==='appyhour' ? ' \u00b7 '+SIZES.find(s=>s.id===state.size).name : ' \u00b7 '+PACKS.find(p=>p.id===state.pack).name));
  btn.textContent = isPicker ? (btn.dataset.choose||'Choose my AppyHour')
    : (hasBox ? (btn.dataset.checkout||'Checkout') : (btn.dataset.add||'Add to cart'));
}
function stickyAction(){
  if(state.stage==='picker'){ scrollToPlans(); }
  else if((cartState.items||[]).some(isSubItem)){ checkout(); }
  else { addConfiguredToCart(); }
}


/* =================================================================
   SHOPIFY CART — the real AJAX cart (/cart/*.js) is the source of truth.
   The builder writes to it; the drawer reads from it. One subscription at a
   time: adding a box first removes any existing subscription line.
   ================================================================= */
const SHOP = {
  boxProductId: 9737594896664,
  bitesProductId: 10177967554840,
  boxPlan4wk: 5989826840,    // AppyHour Box · "Delivery Every 4 Weeks" (Recharge app 294517)
  bitesPlan4wk: 6693257496,  // Gourmet Bites · "Every 4 Weeks"
  // Box variants are the current "Monger's Table" curation (Medium = 7 items,
  // Large = 9 items). These rotate each season — update when the curation changes.
  sizeVariant: { medium: 50044204056856, large: 50044204089624 },
  packVariant: { '6': 51835146043672, '10': 52008615772440 },
};
const SUB_VARIANTS = new Set([50044204056856,50044204089624,51835146043672,52008615772440]);
const VARIANT_TO_ADDON = {}; ADDONS.forEach(a=>{ if(a.variant) VARIANT_TO_ADDON[a.variant]=a.id; });

/* Sync builder prices to the live Shopify variant prices (window.AH_PRICES,
   server-rendered above) so SIZES/PACKS can never diverge from checkout.
   Falls back to the hard-coded prices if AH_PRICES is empty. */
(function(){
  const P = window.AH_PRICES || {};
  SIZES.forEach(s=>{ const v=SHOP.sizeVariant[s.id]; if(P[v]!=null) s.price=P[v]; });
  PACKS.forEach(p=>{ const v=SHOP.packVariant[p.id]; if(P[v]!=null) p.price=P[v]; });
})();

/* live cart snapshot, refreshed by hydrateCart() */
let cartState = { items:[], item_count:0, items_subtotal_price:0, total_price:0, total_discount:0 };
function isSubItem(it){ return !!it.selling_plan_allocation || SUB_VARIANTS.has(it.variant_id); }
function cartCount(){ return cartState.item_count||0; }

/* ---- Ajax Cart API helpers ---- */
async function cartAdd(items){
  const r = await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
  if(!r.ok){ const e=await r.json().catch(()=>({})); throw new Error(e.description||('Could not add to cart ('+r.status+')')); }
  return r.json();
}
async function cartChange(line,quantity){
  const r = await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:String(line),quantity})});
  if(!r.ok) throw new Error('Could not update cart ('+r.status+')');
  return r.json();
}
async function cartFetch(){ return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(r=>r.json()); }

/* Pull the live cart, cache it + the cart-level discount, then re-render. */
async function hydrateCart(){
  try { cartState = await cartFetch(); }
  catch(e){ cartState = { items:[], item_count:0, items_subtotal_price:0, total_price:0, total_discount:0 }; }
  // Show ANY discount the cart has — cart-level OR line-level (codes + automatic).
  let _da = (cartState.cart_level_discount_applications||[])[0];
  if(!_da){ for(const it of (cartState.items||[])){ const a=(it.line_level_discount_allocations||[])[0]; if(a && a.discount_application){ _da=a.discount_application; break; } } }
  cartDiscount = (cartState.total_discount>0) ? { code:(_da && _da.title) ? _da.title : 'Discount', amount: cartState.total_discount/100 } : null;
  renderCart(); syncPromoBar(); renderBuilder();
}

/* ---- mutations ---- */
async function addConfiguredToCart(){
  const variant = state.product==='bites' ? SHOP.packVariant[state.pack] : SHOP.sizeVariant[state.size];
  const plan    = state.product==='bites' ? SHOP.bitesPlan4wk : SHOP.boxPlan4wk;
  try {
    const c = await cartFetch();                                   // one subscription at a time:
    for(const it of (c.items||[])){ if(isSubItem(it)) await cartChange(it.key,0); }  // drop existing sub
    await cartAdd([{ id: variant, quantity: 1, selling_plan: plan }]);
    await hydrateCart(); openCart(); showToast(PRODUCTS[state.product].name+' added');
  } catch(e){ showToast(e.message||'Could not add to cart'); }
}
async function addAddon(id,scroll){
  const a = ADDONS.find(x=>x.id===id);
  if(!a || !a.variant){ showToast((a?a.name:'This add-on')+' is unavailable'); return; }
  try { await cartAdd([{ id: a.variant, quantity: 1 }]); await hydrateCart(); showToast(a.name+' added'); if(scroll) openCart(); }
  catch(e){ showToast(e.message||'Could not add'); }
}
async function changeAddon(key,d){
  const it = (cartState.items||[]).find(x=>x.key===key); if(!it) return;
  try { await cartChange(key, Math.max(0, it.quantity+d)); await hydrateCart(); }
  catch(e){ showToast(e.message||'Could not update'); }
}
async function removeLine(key){ try { await cartChange(key,0); await hydrateCart(); } catch(e){ showToast(e.message||'Could not remove'); } }
function renderCart(){
  const nav=document.getElementById('navCount'); if(nav) nav.textContent=cartCount();
  const body=document.getElementById('drBody'),foot=document.getElementById('drFoot');
  if(!body||!foot) return;
  const items=cartState.items||[];
  // Totally empty cart.
  if(!items.length){ body.innerHTML=`<div class="dr-empty"><div class="e">🧀</div><p>Your order is empty.<br>Build a box to get started.</p></div>`; foot.style.display='none'; return; }
  const c=cents=>money(cents/100);
  const subItems=items.filter(isSubItem);
  const hasBox=subItems.length>0;
  let html='';
  // Subscription line(s) — box or bites
  subItems.forEach(it=>{
    const interval=(it.selling_plan_allocation&&it.selling_plan_allocation.selling_plan)?it.selling_plan_allocation.selling_plan.name:'Subscription';
    const isBox=it.product_id===SHOP.boxProductId;
    html+=`<div class="citem"><div class="cthumb"><img src="${it.image||BOX_IMG}" alt=""></div><div class="cmeta"><div class="cn">${it.product_title}</div><div class="csub">${it.variant_title?it.variant_title+' · ':''}${interval}</div>${isBox?`<div class="csub" style="color:var(--success);font-weight:700;margin-top:3px">+ free cheese & jam pairing for life</div>`:''}</div><div class="cright"><div class="cp">${c(it.final_line_price)}</div><button class="crm" onclick="removeLine('${it.key}')">Remove</button></div></div>`;
  });
  if(!hasBox){ html+=`<div class="cart-need-box">Add-ons go with a box. <button class="link-btn" onclick="closeCart();scrollToPlans();">Build your box →</button></div>`; }
  // Add-on / other lines (qty steppers)
  items.filter(it=>!isSubItem(it)).forEach(it=>{
    html+=`<div class="citem"><div class="cthumb"><img src="${it.image||''}" alt=""></div><div class="cmeta"><div class="cn" style="font-size:13px">${it.product_title}</div><div class="cqty"><button onclick="changeAddon('${it.key}',-1)">−</button><span>${it.quantity}</span><button onclick="changeAddon('${it.key}',1)">+</button></div></div><div class="cright"><div class="cp">${c(it.final_line_price)}</div></div></div>`;
  });
  // Upsell add-ons not already in the cart
  const inCart=new Set(items.map(it=>VARIANT_TO_ADDON[it.variant_id]).filter(Boolean));
  const rest=ADDONS.filter(a=>a.variant && !inCart.has(a.id));
  if(rest.length){ html+=`<div class="addons-mini"><h4>Enhance your order</h4>`; rest.forEach(a=>{ html+=`<div class="amini"><div class="athumb"><img src="${a.img}" alt=""></div><div class="an">${a.name}</div><button class="aadd" onclick="addAddon('${a.id}')">Add $${a.price}</button></div>`; }); html+=`</div>`; }
  body.innerHTML=html;
  // Totals — straight from the live cart so the drawer matches checkout.
  const sub=cartState.items_subtotal_price/100;
  const applied=(cartState.total_discount||0)/100;
  const total=cartState.total_price/100;
  document.getElementById('sub').textContent=moneyD(sub);
  const discRow=document.getElementById('discRow');
  if(applied>0 && cartDiscount){ discRow.style.display='flex';
    document.getElementById('discLabel').textContent=cartDiscount.code;
    document.getElementById('discAmt').textContent='-'+moneyD(applied);
    document.getElementById('totWas').textContent=moneyC(sub+SHIP);
  } else { discRow.style.display='none'; document.getElementById('totWas').textContent=''; }
  // First box ships free — shipping is calculated at checkout, shown waived here.
  document.getElementById('shipLine').innerHTML='<span class="ship-was">'+moneyC(SHIP)+'</span><span class="ship-free-txt">FREE</span>';
  document.getElementById('tot').textContent=moneyD(total);
  document.getElementById('saveLine').textContent='';
  // Checkout requires a subscription box
  const co=document.querySelector('.checkout');
  if(co){ if(hasBox){ co.disabled=false; co.textContent=AH_LABELS.checkout||'Checkout securely →'; co.style.opacity='1'; co.style.cursor='pointer'; }
          else { co.disabled=true; co.textContent=AH_LABELS.checkoutEmpty||'Add a box to check out'; co.style.opacity='.55'; co.style.cursor='not-allowed'; } }
  foot.style.display='block';
}
function openCart(){ const o=document.getElementById('overlay'),d=document.getElementById('drawer'); if(o)o.classList.add('open'); if(d)d.classList.add('open'); }
function closeCart(){ const o=document.getElementById('overlay'),d=document.getElementById('drawer'); if(o)o.classList.remove('open'); if(d)d.classList.remove('open'); }
async function applyDiscount(){
  const el=document.getElementById('promoInput'); if(!el) return;
  const code=el.value.trim(); if(!code){ el.focus(); return; }
  const btn=document.getElementById('promoApply'), prev=cartDiscount && cartDiscount.amount ? cartDiscount.amount : 0;
  if(btn){ btn.disabled=true; btn.textContent='…'; }
  try {
    await fetch('/discount/'+encodeURIComponent(code), {credentials:'same-origin'});
    await hydrateCart();
    const d=getCartDiscount();
    if(d && d.amount){ showToast(d.code+' applied \u2014 '+moneyD(d.amount)+' off'); el.value=''; }
    else { showToast('\u201c'+code+'\u201d isn\u2019t valid for this order — it may still apply at checkout'); }
  } catch(e){ showToast('Could not apply that code'); }
  finally { if(btn){ btn.disabled=false; btn.textContent='Apply'; } }
}
function checkout(){ if(!(cartState.items||[]).some(isSubItem)){ showToast(AH_LABELS.checkoutEmpty||'Add a box to check out'); return; } window.location.href='/checkout'; }
function scrollToPlans(){ /* CTAs drop to the Build-a-Box section, not AppyHour Featured */ const el=document.getElementById('builderSection')||document.getElementById('builder')||document.getElementById('plans'); if(!el) return; const y=el.getBoundingClientRect().top+window.pageYOffset-(promoStickyH()+8); window.scrollTo({top:y,behavior:'smooth'}); }
function scrollToId(id){ const el=document.getElementById(id); if(!el) return; const y=el.getBoundingClientRect().top+window.pageYOffset-(promoStickyH()+24); window.scrollTo({top:y,behavior:'smooth'}); }
function scrollToTop(){ window.scrollTo({top:0,behavior:'smooth'}); }
let tt; function showToast(m){ const t=document.getElementById('toast'); if(!t) return; t.textContent=m; t.classList.add('show'); clearTimeout(tt); tt=setTimeout(()=>t.classList.remove('show'),2200); }
function toggleFaq(b){ b.parentElement.classList.toggle('open'); }

/* banner reflects the cart's discount if there is one; otherwise the standing offer copy */
function syncPromoBar(){ const bar=document.getElementById('promoBar'); if(!bar) return; const d=getCartDiscount();
  const P=window.AH_PROMO||{};
  const base=P.base||'Free shipping on your first box · 30-day Happyness Guarantee';
  const disc=P.discount||'{code} applied automatically — {amount} off + free shipping on box one';
  bar.innerHTML = (d&&d.amount) ? disc.replace('{code}',d.code).replace('{amount}',money(d.amount)) : base;
  bar.classList.toggle('promo--active', !!(d&&d.amount)); sizePromoSpacer(); }
/* Sticky promo (position:fixed) is out of flow. We publish its height as
   --ah-promo-h; the CSS reserves that space via padding-top on the (sticky-gated)
   header wrapper — the header is the first section, so that padding offsets the
   whole page below it. The CSS has a 40px fallback so the space is reserved
   before this deferred script runs (no load flash). 0 when not sticky. */
function promoStickyH(){ const p=document.getElementById('promoBar'); return (p && p.classList.contains('promo--sticky') && p.offsetHeight) || 0; }
function sizePromoSpacer(){ document.documentElement.style.setProperty('--ah-promo-h', promoStickyH()+'px'); }
/* Push CONFIG copy into the page (one edit point for section text/CTAs) */
function applyConfig(){
  document.querySelectorAll('.build-cta').forEach(b=>{ b.textContent=CONFIG.buildCta; });
}
function scrollRev(dir){ const r=document.getElementById('revRail'); if(r) r.scrollBy({left:dir*r.clientWidth,behavior:'smooth'}); }
function updateRevArrows(){ const r=document.getElementById('revRail'); const w=r&&r.closest('.rev-railwrap'); if(w) w.classList.toggle('has-overflow', r.scrollWidth>r.clientWidth+4); }
function renderReviews(){
  const rail=document.getElementById('revRail'); if(!rail) return;
  rail.innerHTML=REVIEWS.map(r=>{
    const stars='★'.repeat(r.stars||5);
    const initial=(r.name||'?').trim().charAt(0).toUpperCase();
    return `<div class="rev"><div class="stars">${stars}</div><h4>${r.title}</h4><p>${r.text}</p><div class="who"><span class="av">${initial}</span> ${r.name} <span class="verified">✓ Verified</span></div></div>`;
  }).join('');
  updateRevArrows();
}
renderReviews();
window.addEventListener('resize', updateRevArrows);
window.addEventListener('resize', sizePromoSpacer);
window.addEventListener('load', sizePromoSpacer);
applyConfig();
syncPromoBar();
sizePromoSpacer();
renderBuilder(); renderCart();
hydrateCart();   // pull the live Shopify cart and repaint drawer + discount
